import { render, staticRenderFns } from "./ProductsSort.vue?vue&type=template&id=4f473ed8&scoped=true&"
import script from "./ProductsSort.vue?vue&type=script&lang=js&"
export * from "./ProductsSort.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSort.vue?vue&type=style&index=0&id=4f473ed8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f473ed8",
  null
  
)

export default component.exports